export default {
  trainingPlan: {
    title: 'トレーニングプラン',
    subtitle: '完璧なトレーニングプランを選んで、成功への旅を始めましょう',
    metaTitle: 'トレーニングプラン - Running Wild',
    metaDescription: 'すべてのレベルのランナー向けの包括的なトレーニングプラン。5Kからマラソンまで、詳細な週間ワークアウトを含むパーソナライズされたトレーニングスケジュールを取得。',
    recommended: 'おすすめ',
    weeks: '週',
    distance: '距離',
    targetTime: '目標時間',
    startPlan: 'このプランを開始',
    backToPlans: 'プラン一覧に戻る',
    trainingZones: 'トレーニングゾーン',
    weeklySchedule: '週間スケジュール',
    selectWeek: '週を選択',
    setGoal: '目標を設定',
    setRaceGoal: 'レース目標を設定',
    goalDescription: 'レース日の目標完走時間を設定してください。これによりトレーニングプランがカスタマイズされます。',
    targetHours: '目標時間',
    hoursPlaceholder: '時間',
    minutesPlaceholder: '分',
    secondsPlaceholder: '秒',
    saveGoal: '目標を保存',
    cancel: 'キャンセル',
    invalidTime: '有効な時間を入力してください。',
    goalSaved: '目標が正常に保存されました！',
    readyToStart: '準備はできましたか？',
    actionSubtitle: 'トレーニングの旅を始めるための次のステップを選択してください',
    startTrainingDesc: 'トレーニングプログラムを開始',
    setGoalDesc: '目標完走時間を定義',
    downloadPlanDesc: 'プランをデバイスに保存',
    sharePlan: 'プランを共有',
    sharePlanDesc: '友達と共有',
    goalSet: '目標設定済み',
    clearGoal: '目標をクリア',
    goalCleared: '目標が正常にクリアされました！',
    week: '週',
    startTraining: 'トレーニング開始',
    downloadPlan: 'プランをダウンロード',
    downloadSuccess: 'トレーニングプラン「{planName}」が正常にダウンロードされました！',
    downloadError: '先にトレーニングプランを選択してください。',
    planOverview: 'プラン概要',
    goalTime: '目標時間',
    goalStatus: '目標ステータス',
    active: 'アクティブ',
    // Additional keys for TrainingPlan.vue
    targetPace: '目標ペース',
    goalAdjusted: '目標調整済み',
    noTraining: 'トレーニングなし',
    recoveryAndRestDay: '回復と休息日',
    days: {
      monday: '月曜日',
      tuesday: '火曜日',
      wednesday: '水曜日',
      thursday: '木曜日',
      friday: '金曜日',
      saturday: '土曜日',
      sunday: '日曜日'
    },
    startTrainingMessage: 'トレーニングプランを開始します！',
    shareError: '共有するプランが選択されていません',
    shareCopied: 'リンクがクリップボードにコピーされました！',
    sharePrompt: 'このリンクをコピー:'
  },
  home: {
    heroTitle: '柔軟でカスタマイズ可能な全スポーツ対応イベントルールプラットフォーム',
    heroSubtitle: 'ペース、心拍数、時間、Strava対応のあらゆるスポーツでイベントを作成できます。',
    getStarted: 'はじめる',
    seeHowItWorks: '使い方を見る',
    featuresTitle: 'なぜ私たちのプラットフォーム？',
    subscriptionPlans: 'サブスクリプションプラン',
    subscriptionDesc: 'あなたのランニングジャーニーに最適なプランを選択',
    recommended: 'おすすめ',
    month: '月',
    save: '節約',
    unlimitedActivities: 'アクティビティ無制限追跡',
    aiAnalysis: 'AI分析機能',
    prioritySupport: '優先サポート',
    subscribeNow: '今すぐ登録',
    plan: 'プラン',
    duration: '期間',
    totalPrice: '合計金額',
    pricePerMonth: '月額',
    youSave: '節約額',
    paymentInstructions: 'お支払い方法',
    bankTransfer: '銀行振込',
    bankName: '銀行名',
    accountNumber: '口座番号',
    accountName: '口座名義',
    amount: '金額',
    transferNote: '振込メモ（重要！）',
    transferNoteDesc: '振込の際に必ずこのメモを記入してください:',
    copy: 'コピー',
    noteWarning: 'このメモがないと、お支払いを確認できません！',
    scanQrCode: 'QRコードをスキャン',
    qrCodeDesc: '銀行アプリでこのQRコードをスキャンしてください:',
    qrNote: 'QRコードには口座情報が含まれています。振込メモの追加をお忘れなく！',
    activationTime: 'アクティベーション時間',
    activationDesc: 'お支払い確認後24時間以内にサブスクリプションが有効化されます。有効化されるとプロフィールにPROバッジが表示されます。',
    activationContact: 'ご質問がございましたら、こちらまでお問い合わせください：',
    enterStravaId: 'Strava IDを入力',
    stravaIdDesc: 'StravaアスリートIDを入力してください。プロフィールのURLで確認できます。',
    stravaIdPlaceholder: '例：12345678',
    invalidStravaId: '有効な数値のStrava IDを入力してください',
    howToFindStravaId: 'Strava IDの見つけ方：',
    goToProfile: 'プロフィールにアクセス',
    stravaIdInUrl: 'してURLを確認（例：strava.com/athletes/12345678）',
    subscribingAs: '登録者',
    stravaIdRequired: 'Strava IDを入力してください。',
    invalidStravaIdError: '有効な数値のStrava IDを入力してください。',
    missingInfo: '情報不足',
    invalidInput: '無効な入力',
    paymentNote: 'サブスクリプションが有効化されると通知が届きます。',
    rateLimitError: 'リクエストが多すぎます。後でもう一度お試しください。',
    errorContact: '問題が解決しない場合は、こちらまでお問い合わせください：',
    cancel: 'キャンセル',
    paymentMade: '支払いを完了しました',
    copiedToClipboard: 'コピーしました！',
    paymentReceived: 'お支払い確認',
    paymentConfirmMessage: 'ありがとうございます！お支払い確認後24時間以内にサブスクリプションが有効化されます。',
    activePlan: '有効なプラン',
    pendingPlan: '支払い確認待ち',
    suspendedPlan: 'サブスクリプション停止中',
    status: 'ステータス',
    activeStatus: '有効',
    pendingStatus: '保留中',
    validPeriod: '有効期間',
    daysRemaining: '残り日数',
    days: '日',
    pendingMessage: 'お支払いありがとうございます！サブスクリプションを処理中です。',
    pendingTimeline: 'お支払いの確認後、24時間以内にサブスクリプションが有効化されます。有効化されましたら通知いたします。',
    needHelp: 'サポートが必要ですか？',
    pendingContact: 'サポートチームまでお問い合わせください',
    suspendedMessage: 'サブスクリプションが停止されました。プレミアム機能を引き続きご利用いただくには、以下から新しいプランをお選びください。',
    suspendedContact: 'ご質問がある場合は、こちらまでお問い合わせください',
    paymentError: 'お支払い確認の送信中にエラーが発生しました。サポートまでお問い合わせください。',
    error: 'エラー',
    featureCustomRules: 'カスタムルールエンジン',
    featureCustomRulesDesc: 'ペース、心拍数、時間枠などを設定し、イベントルールを自由自在に。',
    featureMultiSport: 'マルチスポーツ対応',
    featureMultiSportDesc: 'ランニングだけでなく、スイム、バイク、Stravaの全スポーツに対応。',
    featureRuleCustomization: 'ルールカスタマイズ',
    featureRuleCustomizationDesc: 'ペース、心拍数、高度、活動日などを自由に設定。特定の時間に走るとポイント2倍・3倍！',
    featureTrainingPlans: 'トレーニングプラン',
    featureTrainingPlansDesc: 'ハーフマラソンとフルマラソンのための構造化されたワークアウトと目標設定を含む専門的なトレーニングプラン。',
    trackYourGoal: '目標を設定',
    trackYourGoalDesc: '自分の目標を定め、静かに粘り強く追いかけよう。',
    howItWorksTitle: '使い方の流れ',
    howStep1: 'イベントを作成',
    howStep2: 'カスタムルールを定義',
    howStep3: '参加者を招待',
    howStep4: '結果を追跡＆祝福',
    topAthletes: 'トップアスリート',
    topEvents: '注目イベント',
    participants: '参加者',
    eventsCreated: '作成済みイベント',
    sportsSupported: '対応スポーツ',
    ctaTitle: '自分だけのイベントを作りませんか？',
    ctaDesc: '今すぐ始めて、最も柔軟なイベントプラットフォームを体験しよう。',
    trainingPlansTitle: '専門的なトレーニングプラン',
    trainingPlansSubtitle: 'ハーフマラソンとフルマラソンのためのエキスパート設計のトレーニングプランから選択。各プランには構造化されたワークアウト、目標設定、進捗追跡が含まれます。',
    halfMarathonPlan: 'ハーフマラソンプラン',
    halfMarathonPlanDesc: '21.1km距離の16週間構造化トレーニングプラン',
    fullMarathonPlan: 'フルマラソンプラン',
    fullMarathonPlanDesc: '42.2km距離の16週間包括的トレーニングプラン',
    weeks: '週間',
    distance: '距離',
    targetTime: '目標時間',
    startTrainingPlan: 'トレーニングプランを開始',
    footerText: '全著作権所有。',
    about: '私たちについて',
    contact: 'お問い合わせ',
    latestActivity: '最新のアクティビティ',
    // Special Features Section
    specialFeatures: '特別な機能',
    specialFeaturesDesc: 'ランナー向けに設計されたユニークなツールを発見',
    makeKorlorTitle: 'MakeKorlor',
    makeKorlorDesc: 'GPXファイルから音楽同期付きの美しいアニメーションルート動画を作成',
    trainingPlanTitle: 'トレーニングプラン',
    trainingPlanDesc: '5K、10K、ハーフマラソン、マラソンのためのパーソナライズされたトレーニングプラン',
    uploadGpx: 'GPXファイルをアップロード',
    addMusic: '背景音楽を追加',
    animateRoute: 'ルートをアニメーション化',
    exportVideo: 'アニメーション動画をエクスポート',
    weeklySchedules: '週間スケジュール',
    goalSetting: '目標設定',
    progressTracking: '進捗追跡',
    exportPlans: 'プランをエクスポート',
    tryMakeKorlor: 'MakeKorlorを試す',
    startTraining: 'トレーニングを開始',
    // Login CTA Section
    redirectingToFeed: 'アクティビティフィードにリダイレクト中...',
    joinCommunity: 'ランニングコミュニティに参加しよう！',
    loginBenefit: 'ランナー仲間とつながり、進捗を追跡し、限定機能にアクセスしよう',
    connectRunners: 'ランナーとつながる',
    trackProgress: '進捗を追跡',
    exclusiveFeatures: '限定機能',
    loginNow: 'Stravaでログイン',
    freeToJoin: '無料で数秒で完了！'
    ,
    // Subscription & AI Coach additions
    aiCoachTitle: 'AIランニングコーチを解放',
    aiCoachSubtitle: '毎回のランを実行可能なインサイトに。賢く練習し、停滞を避け、新PBへ。',
    seePlans: 'プランと料金を見る',
    learnMore: '詳しく見る',
    weeklyVolume: '週間走行距離',
    easyPace: 'イージーペース',
    sleepRecovery: '回復スコア',
    formSignal: 'フォームシグナル',
    stable: '安定',
    compareTitle: 'なぜPRO？',
    free: '無料',
    pro: 'PRO',
    freeBasicTracking: '基本的なトラッキング',
    freeHistory: '最近の履歴のみ',
    freeCommunity: 'コミュニティフィード',
    proSmartInsights: '毎回のラン後のスマートインサイト',
    proPersonalPlans: 'パーソナライズされた練習ナッジ',
    proFormSignals: 'テクニック・努力のシグナル',
    proTrendlines: 'トレンドラインと進捗追跡',
    proPrioritySupport: '優先サポート',
    faqTitle: 'よくある質問',
    // AI hero points
    aiPointPersonalizedInsightsTitle: 'パーソナライズドインサイト',
    aiPointPersonalizedInsightsDesc: '毎回のラン後に、シンプルで実行しやすい提案を受け取る。',
    aiPointTrainSmarterTitle: 'スマートに練習',
    aiPointTrainSmarterDesc: 'オーバートレーニングを避けながら進歩を促す適応的なナッジ。',
    aiPointSeeProgressTitle: '本当の進歩を可視化',
    aiPointSeeProgressDesc: '何が本当に改善しているかを示すトレンドライン。',
    aiPointStayMotivatedTitle: 'モチベーション維持',
    aiPointStayMotivatedDesc: 'マイルストーンと連続達成が継続をサポート。',
    // How it works (subscription AI)
    howConnectTitle: 'アクティビティを連携',
    howConnectDesc: 'いつも通り走るだけ。自動で同期・分析します。',
    howAnalyzeTitle: 'AIがパターンを分析',
    howAnalyzeDesc: 'ペース・努力・継続性のトレンドを検出します。',
    howGuidanceTitle: '明快なガイダンス',
    howGuidanceDesc: '次のランですぐ使える短いヒント。',
    // FAQ
    faqQ1: 'AIアナリシスはどのように走りを改善しますか？',
    faqA1P1: '複雑なデータをシンプルなヒントに要約します：何をもっと、何を減らし、何を変えるべきか。',
    faqA1P2: '単一のセッションだけでなく、数週間にわたるパターンが見えるようになります。',
    faqQ2: 'PROは初心者に適していますか？',
    faqA2P1: 'はい。ガイダンスは平易な言葉で書かれており、シンプルな次のステップに焦点を当てています。',
    faqA2P2: '初心者にも経験豊富なランナーにも、プラトーを避けるのに役立ちます。',
    faqQ3: '支払い後に何が得られますか？',
    faqA3P1: 'サブスクリプションは確認後24時間以内にアクティベートされます。',
    faqA3P2: 'PROバッジが表示され、AIインサイトが自動的にロック解除されます。',
    faqQ4: 'いつでもキャンセルできますか？',
    faqA4P1: 'はい。プランは支払済期間の最後まで実行され、その後停止します。',
    faqA4P2: '隠れた料金はありません。'
  },
  eventDetail: {
    title: 'イベント詳細',
    selectLevel: 'レベルを選択してください',
    selectTeam: 'チームを選択してください',
    enterPaceTarget: 'ペース目標を入力してください',
    invalidPaceTarget: '有効なペース目標を入力してください（例：5p30 または 5p00）',
    codeMismatch: 'コードが間違っています / コードが一致しません',
    joinCode: '参加コード',
    level: 'レベル',
    team: 'チーム',
    personalTarget: '個人目標',
    paceTarget: '目標ペース（5m30）',
    paceFormatHelp: '形式：5m30 または 5m00',
    join: '参加',
    dashboard: 'ダッシュボード',
    teamDashboard: 'チームダッシュボード',
    upcoming: '今後の予定',
    expired: '終了済み',
    active: '進行中',
    scoringRules: 'スコアリングルール',
    error: 'エラー',
    varDashboard: 'サマリーテーブル'
  },
  profile: {
    updateSuccess: 'プロフィールが正常に更新されました！',
    updateFailed: 'プロフィールの更新に失敗しました',
    success: '成功',
    error: 'エラー',
    validationError: '検証エラー',
    pleaseFixValidationErrors: '送信前に検証エラーを修正してください',
    athleteNotFound: 'アスリートが見つかりません',
    pleaseLoginAgain: 'プロフィールを更新するには、もう一度ログインしてください',
    redirectingToLogin: '認証が見つかりません。Stravaログインにリダイレクトしています...',
    achievementLoadFailed: '実績の読み込みに失敗しました',
    id: 'ID:',
    email: 'メールアドレス:',
    athlete_name: '名前:',
    total_activities: '総活動数:',
    proMember: 'プロ会員 - プレミアムサブスクリプション有効',
    noChallenges: 'まだチャレンジがありません',
    joinChallenges: 'ワクワクするチャレンジに参加して、フィットネスの旅を始めましょう！',
    editProfile: 'プロフィール編集',
    save: '保存',
    saving: '保存中...',
    optional: '任意',
    emailAddress: 'メールアドレス',
    emailPlaceholder: 'メールアドレスを入力してください',
    invalidEmail: '有効なメールアドレスを入力してください。',
    // Profile configuration fields
    age: '年齢',
    agePlaceholder: '年齢を入力してください',
    invalidAge: '有効な年齢を入力してください（1-120）',
    weight: '体重',
    weightPlaceholder: '体重を入力してください',
    invalidWeight: '有効な体重を入力してください（1-500 kg）',
    height: '身長',
    heightPlaceholder: '例：168',
    heightHelp: '身長をセンチメートルで入力してください（例：168 cm）',
    invalidHeight: '有効な身長を入力してください（50-300 cm）',
    gender: '性別',
    selectGender: '性別を選択',
    genderMale: '男性',
    genderFemale: '女性',
    genderUnknown: '不明',
    invalidGender: '性別を選択してください',
    autoAnalyseAndShare: 'Stravaに自動分析＆共有',
    autoAnalyseAndShareHelp: '新しいアクティビティを作成すると、AI分析を自動生成してStravaに共有',
    trainingTarget: 'トレーニング目標',
    trainingTargetHelp: 'レースの目標を設定して進捗を追跡',
    targetFinishTime: '目標完走タイム',
    targetFinishTimeHelp: '例：フルマラソンサブ4の場合、4時間0分と入力',
    targetRaceDate: '目標レース日',
    targetRaceDateHelp: '目標レースはいつですか？ (形式: MM-DD-YYYY)',
    targetSportTypes: '目標スポーツ種目',
    targetSportTypesHelp: 'トレーニングしたいスポーツを選択（複数選択はCtrl/Cmdキーを押しながら）',
    goalDescription: '目標の説明',
    goalDescriptionPlaceholder: 'トレーニングの目標、達成したいこと、目標レース、または具体的な目標について説明してください...',
    goalDescriptionHelp: 'この説明はAIがよりパーソナライズされたトレーニング分析を提供するために使用されます',
    sportRunning: 'ランニング',
    sportCycling: 'サイクリング',
    sportSwimming: '水泳',
    sportTriathlon: 'トライアスロン',
    hours: '時間',
    minutes: '分',
    hoursPlaceholder: '時',
    minutesPlaceholder: '分',
    myChallenges: 'マイチャレンジ',
    upcoming: '今後の予定',
    ended: '終了済み',
    active: '進行中',
    start: '開始',
    end: '終了',
    viewDetails: '詳細を見る',
    dashboard: 'ダッシュボード',
    myAchievement: 'マイアチーブメント',
    loadingMoreChallenges: 'さらにチャレンジを読み込み中...',
    loadingAchievement: 'アチーブメントを読み込み中...',
    noAchievementData: 'アチーブメントデータがありません。',
    activityList: 'アクティビティリスト',
    type: 'タイプ',
    name: '名前',
    date: '日付',
    km: 'Km',
    movingTime: '時間',
    pace: 'ペース',
    showStats: '統計を表示',
    hideStats: '統計を非表示',
    count: '件数',
    block: 'ブロック',
    blocks: 'ブロック',
    points: 'ポイント',
    changeAvatar: 'アバターを変更',
    uploadAvatar: 'アバターをアップロード',
    dragDropOrClick: 'ここに画像をドラッグ＆ドロップするか、クリックして選択',
    supportedFormats: '対応形式: JPG, PNG, GIF (最大5MB)',
    fileSizeError: 'ファイルサイズは5MB未満である必要があります',
    selectedFile: '選択されたファイル',
    noFileSelected: 'アップロードするファイルを選択してください',
    avatarUploadSuccess: 'アバターのアップロードが成功しました！',
    avatarUploadFailed: 'アバターのアップロードに失敗しました',
    sessionExpired: 'セッションの有効期限が切れました。再度ログインしてください。',
    authenticationRequired: '認証が必要です',
    aiGen: 'AI Gen',
    aiImageGen: '画像生成',
    aiVideoGen: '動画生成',
    aiTracklogStats: 'AIトラックログ統計',
    dailyAiAnalysisLimitExceeded: '1日のAI分析制限に達しました。明日再試行してください。',
    aiAnalysisError: 'AI分析エラー',
    aiAnalysisThinking: 'AIが思考中...',
    aiAnalysisThinkingDescription: 'あなたの現在の活動を最近の公開データと比較中',
    comparisonPeriod: '比較期間',
    activitiesAnalyzed: '分析活動数',
    loadingAiGen: 'AI生成データを読み込み中...',
    tracklogList: 'トラックログリスト',
    tracklogName: 'トラックログ名',
    dateTime: '日時',
    actions: 'アクション',
    noTracklogData: 'トラックログデータがありません。',
    aiGeneratedImage: 'AI生成画像',
    aiGeneratedVideo: 'AI生成動画',
    generatingImage: 'AI画像を生成中...少し待ってください、またはAI生成タブで進捗を確認できます',
    generatingVideo: 'AI動画を生成中...少し待ってください、またはAI生成タブで進捗を確認できます',
    aiGeneratedFor: 'AI生成対象',
    generatedOn: '生成日時',
    downloadImage: '画像をダウンロード',
    downloadVideo: '動画をダウンロード',
    openInNewTab: '新しいタブで開く',
    shareImage: '画像を共有',
    shareVideo: '動画を共有',
    onlyMe: '自分だけ',
    makePublic: '公開する',
    privacyUpdated: 'プライバシーが更新されました',
    privacyUpdateFailed: 'プライバシーの更新に失敗しました',
    uploadSourceImage: 'ソース画像をアップロード',
    dragDropImage: 'ここに画像をドラッグ＆ドロップするか、クリックして選択',
    changeImage: '画像を変更',
    uploadingImage: '画像をアップロード中...',
    invalidFileType: '無効なファイルタイプです。画像ファイルを選択してください。',
    fileTooLarge: 'ファイルが大きすぎます。最大サイズは10MBです。',
    uploadFailed: 'ファイルのアップロードに失敗しました',
    videoNotSupported: 'お使いのブラウザはvideoタグをサポートしていません。',
    // AI History
    myAiHistory: 'マイAI履歴',
    loadingAiHistory: 'AI履歴を読み込み中...',
    errorLoadingAiHistory: 'AI履歴の読み込みに失敗しました',
    noAiHistory: 'AI履歴がありません',
    generateAiContent: 'アクティビティのAIコンテンツを生成してここで確認してください！',
    refreshAiHistory: 'AI履歴を更新',
    refresh: '更新',
    startPolling: '自動更新',
    stopPolling: '自動更新を停止',
    autoRefreshing: '自動更新中...',
    aiHistoryUpdated: 'AI履歴が更新されました',
    updateNotification: '更新',
    pollingStopped: 'エラーのため自動更新を停止しました',
    pollingError: '接続エラー',
    // No activities modal
    noActivitiesModalTitle: 'アクティビティが見つかりません',
    tooFewActivities: 'アクティビティが少なすぎます',

    noActivitiesModalMessage: 'まだアクティビティが同期されていません。Stravaアクティビティを同期してここで確認するか、イベントに参加して新しいアクティビティを追跡しましょう。',
    tooFewActivitiesMessage: 'AIコンテンツを生成するための十分なアクティビティがありません。Stravaアクティビティを同期してここで確認するか、イベントに参加して新しいアクティビティを追跡しましょう。',

    tooFewActivitiesModalSyncSuccess: 'アクティビティの同期が完了しました！',
    noActivitiesModalSyncActivities: 'すべてのアクティビティを同期',

    tooFewActivitiesModalSyncActivities: 'すべてのアクティビティを同期',
    noActivitiesModalExploreEvents: 'イベントを探す',

    tooFewActivitiesModalExploreEvents: 'イベントを探す',
    noActivitiesModalClose: '閉じる',

    tooFewActivitiesModalClose: '閉じる',
    noActivitiesModalSyncing: 'アクティビティを同期中...',

    tooFewActivitiesModalSyncing: 'アクティビティを同期中...',
    noActivitiesModalSyncSuccess: 'アクティビティの同期が完了しました！',
    noActivitiesModalSyncStarted: 'アクティビティの同期が開始されました！数分かかる場合があります。',

    tooFewActivitiesModalSyncStarted: 'アクティビティの同期が開始されました！数分かかる場合があります。',
    noActivitiesModalSyncError: 'アクティビティの同期に失敗しました',

    tooFewActivitiesModalSyncError: 'アクティビティの同期に失敗しました',
    syncInProgressTitle: '同期中',

    noActivitiesModalSyncFeature: 'すべてのStravaアクティビティを同期してここで確認',
    tooFewActivitiesModalSyncFeature: 'すべてのStravaアクティビティを同期してここで確認',

    noActivitiesModalJoinEventsFeature: 'カスタムルールとチャレンジのあるイベントに参加',
    tooFewActivitiesModalJoinEventsFeature: 'カスタムルールとチャレンジのあるイベントに参加',

    noActivitiesModalTrackProgressFeature: '進捗と実績を追跡',
    tooFewActivitiesModalTrackProgressFeature: '進捗と実績を追跡',
    activityId: 'アクティビティID',
    contentType: 'コンテンツタイプ',
    status: 'ステータス',
    contentUrl: 'コンテンツURL',
    contentTitle: 'コンテンツ',
    contentText: 'コンテンツ',
    viewAnalysis: '分析を表示',
    updatedAt: '更新日時',
    createdAt: '作成日時',
    viewContent: 'コンテンツを表示',
    noContent: 'コンテンツなし',
    previous: '前へ',
    next: '次へ',
    showingResults: '{total}件中{start}-{end}件を表示',
    unknown: '不明',
    statusTitle: 'ステータス',
    // Preview functionality
    preview: 'プレビュー',
    previewContent: 'コンテンツをプレビュー',
    open: '開く',
    loadingContent: 'コンテンツを読み込み中...',
    failedToLoadContent: 'コンテンツの読み込みに失敗しました',
    tapToZoom: 'タップしてズーム',
    daily_ai_generation_limit_exceeded: '1日のAI生成制限を超えました。明日もう一度お試しください。走更多の活動をしてもっと多くのクレジットを獲得しましょう（すぐに ^.^）',
    aiStatus: {
      started: '開始済み',
      finished: '完了',
      failed: '失敗',
      processing: '処理中',
      error: 'エラー'
    },
    // Privacy controls
    privacy: 'プライバシー',
    public: '公開',
    private: '非公開',
    makePrivate: '非公開にする',
    contentMadePublic: 'コンテンツが公開されました',
    contentMadePrivate: 'コンテンツが非公開になりました',
    notAvailable: 'N/A',
    // Additional missing keys
    uploadImageForAiImage: 'AI用画像をアップロード',
    dragDropImageForAiImage: 'AI用にここに画像をドラッグ＆ドロップするか、クリックして選択',
    uploadingAvatar: 'アバターをアップロード中...'
  },
  progress: {
    title: '進捗トラッカー',
    loading: '進捗データを読み込み中...',
    totalDistance: '総距離',
    totalTime: '総時間',
    activities: 'アクティビティ',
    totalElevation: '総獲得標高',
    avgPace: '平均ペース',
    avgHR: '平均心拍数',
    longestRun: '最長ラン',
    longestRide: '最長ライド',
    byType: 'タイプ別アクティビティ',
    weeklyTrend: '週間トレンド',
    noData: 'この期間のアクティビティデータはありません',
    errorLoadingProgress: '進捗データの読み込みエラー',
    unknown: '不明',
    last7Days: '過去7日間',
    last30Days: '過去30日間',
    last90Days: '過去90日間',
    eventPeriod: 'イベント期間',
    customRange: 'カスタム範囲',
    vsPreviewPeriod: '前期間比',
    daysRemaining: '残り日数',
    progressComplete: '完了'
  },
  events: {
    error: 'エラー',
    title: 'イベント',
    noEvents: '利用可能なイベントはありません',
    join: '参加',
    upcoming: '今後の予定',
    expired: '終了済み',
    loading: 'イベントを読み込み中...',
    loadMore: 'もっとイベントを表示'
  },
  login: {
    title: 'ログイン',
    brand: 'Nghiện Chạy Bộ',
    welcome: 'コミュニティへようこそ！',
    instruction: 'Stravaでログインをクリックして、私たちと一緒にランニングの旅を始めましょう。みんなと成果を共有しよう！',
    loginWithStrava: 'Stravaでログイン',
    redirecting: 'リダイレクト中...',
    step1: '上記のStravaでログインボタンをクリックしてください',
    guideAlt: 'ログインガイド',
    step2: 'nghienchaybo.comがあなたのStravaデータを同期できるように「Authorize」を選択してください',
    step3: 'その後、あなたのStravaデータは自動的にnghienchaybo.comに同期されます',
    error: 'ログインエラー'
  },
  eventVar: {
    group: 'グループ',
    activityName: 'アクティビティ名',
    teamName: 'チーム名',
    pace: 'ペース',
    distance: '距離',
    movingTime: '移動時間',
    elapsedTime: '経過時間',
    avgHR: '平均心拍数',
    avgWatts: '平均ワット',
    elevHigh: '最高高度',
    elevLow: '最低高度',
    avgCadence: '平均ケイデンス',
    inspectionResults: '検査結果',
    noSimilarActivities: '類似のアクティビティは見つかりませんでした。',
    pageSize: 'ページサイズ：',
    close: '閉じる',
    // MISSING KEYS FROM ENGLISH (translated to Japanese):
    loading: 'チーム統計を読み込み中...',
    error: 'データの読み込みエラー',
    retry: '再試行',
    export: 'CSVエクスポート',
    exportCSV: 'CSVにエクスポート',
    refresh: '更新',
    searchPlaceholder: '名前またはチームで検索...',
    allTeams: '全チーム',
    allGenders: '全性別',
    male: '男性',
    female: '女性',
    clearFilters: 'フィルターをクリア',
    teamStats: 'チーム統計',
    rank: '順位',
    athlete: 'アスリート',
    gender: '性別',
    team: 'チーム',
    totalAthletes: '{count}人のアスリート',
    showing: '{count} / {total}人を表示中',
    previous: '前へ',
    next: '次へ',
    largeScreenTitle: '大画面での表示推奨',
    largeScreenMessage: 'このページはデスクトップやタブレットでの閲覧に最適化されています。最良の体験のために大きな画面をご利用ください。',
    featureTable: '全データ列のフルテーブル表示',
    featureFilters: '高度な検索・フィルター機能',
    featureExport: 'CSV形式でデータをエクスポート',
    continueAnyway: '続行する',
    teamDashboard: 'チームダッシュボード',
    eventDashboard: 'イベントダッシュボード',
    inspection: '検査',
    inspectionLoading: 'トラックログを解析中...',
    inspectionSubtitle: 'このセクションは類似ルートや不審なパターンのアクティビティグループを表示します。各グループは重複や異常の可能性を示します。',
    showingGroups: '{from}～{to} / {total}グループを表示中',
    jumpToPage: 'ページ：'
  },
  eventDashboard: {
    var: 'Var',
    io: 'I/O',
    dateTime: '日付時刻',
    soiiReport: 'Soii/報告',
    inSportWeTrust: 'スポーツに信頼を！気楽にいこう (^.^)',
    failedInspection: '検査結果の読み込みに失敗しました。',
    // MISSING KEYS FROM ENGLISH (translated to Japanese):
    title: 'イベントダッシュボード',
    filter: 'フィルター＆検索',
    level: 'レベル',
    overall: '総合',
    female: '女性',
    male: '男性',
    team: 'チーム',
    search: '検索',
    searchPlaceholder: 'アスリート名を入力...',
    ranking: 'ランキング',
    participants: '{count} 人の参加者',
    page: 'ページ {current}/{total}',
    points: 'ポイント',
    actions: '操作',
    inspect: '詳細',
    cert: '認定証',
    next: '次へ',
    prev: '前へ',
    first: '最初',
    last: '最後',
    results: '件',
    join: '参加',
    stats: '統計',
    total: '合計',
    type: '種目',
    name: '名前',
    date: '日付',
    km: 'Km',
    pace: 'ペース',
    report: '報告',
    activityDetails: 'アクティビティ詳細',
    totalPoints: '合計ポイント:',
    totalKm: '合計Km:',
    totalDays: '合計日数:',
    summaryByType: '種目別サマリー（{count}件のアクティビティ）：',
    number: '#',
    teamName: 'チーム名',
    levelName: 'レベル名',
    eventName: 'イベント名',
    eventDates: '{from} - {to}',
    statusUpcoming: '今後の予定',
    statusExpired: '終了済み',
    statusActive: '進行中',
    activityList: 'アクティビティリスト',
    viewOnStrava: 'Stravaで見る',
    resetFilters: 'すべてのフィルターをリセット',
    loadingAthletes: 'アスリートを読み込み中...',
    times: '回'
  },
  teamEventDashboard: {
    loadingMoreTeams: 'チームをさらに読み込み中...',
    noTeamsFound: 'チームが見つかりません',
    noTeamsJoined: 'このイベントにはまだチームが参加していません。',
    // MISSING KEYS FROM ENGLISH (translated to Japanese):
    title: 'チームイベントダッシュボード',
    noTeams: '利用可能なチームはありません',
    join: 'チームに参加',
    team: 'チーム',
    teams: 'チーム一覧',
    members: 'メンバー',
    points: 'ポイント',
    rank: '順位',
    upcoming: '今後の予定',
    expired: '終了済み',
    teamsCount: '{count} {teamLabel}',
    loadingTeams: 'チームを読み込み中...'
  },
  nav: {
    brand: 'NCB',
    home: 'ホーム',
    events: 'イベント',
    trainingPlans: 'トレーニングプラン',
    gpxAnimator: 'GPXアニメーター',
    eventVar: 'イベントVar',
    guide: 'ログインガイド',
    login: 'ログイン',
    profile: 'プロフィール',
    profileLabel: 'プロフィール',
    logout: 'ログアウト',
    blog: 'ブログ',
    about: '私たちについて',
    createEvent: 'イベント作成'
  },
  app: {
    brand: 'nghienchaybo.com',
    tagline: 'バーチャルスポーツ | ヘルステック - 2025',
    powered: 'Strava 提供 | ベータテスト中',
    home: 'ホーム',
    backToTop: 'トップへ戻る',
    contactUs: 'お問い合わせ',
    email: 'メール',
    phone: '電話',
    affiliateTitle: '提携サイト',
    affiliateYoutube: '👨‍💻 Ahaxuと一緒にプログラミングを学ぼう 👨‍💻',
    affiliate42x: '42xChallenge.Com',
    copyright: '著作権所有。無断転載を禁じます。'
  },
  eventMap: {
    loadingMap: '地図を読み込み中...'
  },
  feed: {
    title: 'アクティビティフィード',
    loadMore: 'もっと読み込む',
    welcomeBack: 'おかえりなさい、{name}さん！',
    athlete: 'アスリート',
    stayConnected: 'ランニングコミュニティとつながりを保とう',
    joinEvent: 'イベント参加',
    profile: 'プロフィール',
    aiYourProfile: 'AIプロフィール',
    recentActivity: '最近のアクティビティ',
    loadingActivities: 'アクティビティを読み込み中...',
    aiGenerated: 'AI生成',
    viewFullSize: 'フルサイズで表示',
    noRecentActivities: '最近のアクティビティがありません',
    followAthletes: 'アスリートをフォローするかイベントに参加して、ここでアクティビティを見よう',
    exploreEvents: 'イベントを探す',
    quickTools: 'クイックツール',
    makeKorlor: 'MakeKorlor',
    trainingPlans: 'トレーニングプラン',
    activityImage: 'アクティビティ画像',
    activity: 'アクティビティ',
    aiGeneratedImage: 'AI生成画像',
    aiGeneratedVideo: 'AI生成動画',
    videoNotSupported: 'お使いのブラウザはHTML5ビデオをサポートしていません。'
  },
  makeKorlor: {
    title: 'GPX 3D アニメーター',
    subtitle: '3Dアニメーションと音楽同期でGPXトラックを可視化',
    uploadGpx: 'GPXファイルをアップロード',
    uploadGpxPlaceholder: 'アニメーションするGPXファイルを選択...',
    addMusic: '音楽を追加（オプション）',
    addMusicPlaceholder: 'オーディオファイルを選択...',
    animationSpeed: 'アニメーション速度：',
    markerSize: 'マーカーサイズ：',
    play: '再生',
    pause: '一時停止',
    reset: 'リセット',
    toggleSatellite: '衛星表示切替',
    toggleTerrain: '地形表示切替',
    toggleStreet: 'ストリート表示切替',
    currentSpeed: '現在の速度：',
    elevation: '標高：',
    distance: '距離：',
    trackInfo: 'トラック情報',
    totalDistance: '総距離：',
    totalTime: '総時間：',
    avgSpeed: '平均速度：',
    maxSpeed: '最大速度：',
    loading: 'GPXファイルを処理中...',
    gpxLoaded: 'GPXファイルが正常に読み込まれました！',
    musicLoaded: '音楽ファイルが読み込まれました！音楽はアニメーション速度と同期されます。',
    defaultMusicLoaded: 'デフォルト音楽が読み込まれました！音楽はアニメーション速度と同期されます。',
    errorLoadingGpx: 'GPXファイルの読み込みエラー：',
    errorLoadingMusic: '音楽ファイルの読み込みエラー：',
    noGpxFile: '先にGPXファイルを読み込んでください！',
    noTrackData: 'エクスポートするトラックデータがありません！',
    processing: 'GPXファイルを処理中...',
    exportSuccess: 'トラックデータが正常にエクスポートされました！',
    speedUp: '🚀 平均より速い！',
    speedDown: '😌 平均より遅い',
    startPoint: 'スタート地点',
    endPoint: 'ゴール地点',
    recordVideo: '動画を録画',
    stopRecording: '録画停止',
    recording: '録画中',
    recordedVideo: '録画された動画',
    videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません。',
    downloadVideo: '動画をダウンロード',
    shareVideo: '動画を共有',
    onlyMe: '自分のみ',
    makePublic: '公開する',
    privacyUpdated: 'プライバシー設定を更新しました',
    privacyUpdateFailed: 'プライバシー設定の更新に失敗しました',
    uploadSourceImage: 'ソース画像をアップロード',
    dragDropImage: 'ここに画像をドラッグ&ドロップするか、クリックして選択',
    changeImage: '画像を変更',
    uploadingImage: '画像をアップロード中...',
    invalidFileType: '無効なファイル形式です。画像ファイルを選択してください。',
    fileTooLarge: 'ファイルが大きすぎます。最大サイズは10MBです。',
    uploadFailed: 'ファイルのアップロードに失敗しました',
    recordingStarted: '録画を開始しました！ブラウザがプロンプトを表示したら、録画したいものを選択してください。',
    recordingStopped: '録画を停止しました。',
    recordingCompleted: '動画録画が完了しました！',
    recordingNotSupported: 'お使いのブラウザは画面録画をサポートしていません。',
    screenAccessDenied: '画面アクセスが拒否されました。画面共有を許可してください。',
    mapNotFound: '地図が見つかりません。もう一度お試しください。',
    noVideoRecorded: 'まだ動画が録画されていません。',
    videoDownloaded: '動画が正常にダウンロードされました！',
    videoShared: '動画リンクがクリップボードにコピーされました！',
    forceStopRecording: '録画を強制停止',
    forceStop: '強制停止',
    recordingForceStopped: '録画を強制停止しました',
    noRecordingData: '録画データがありません',
    recordingError: '録画エラー: {error}',
    animationCompleted: 'アニメーション完了、録画を停止中',
    autoStoppingRecording: 'アニメーション後に録画を自動停止',
    autoSelecting: '自動選択',
    shouldAutoRecord: 'このタブを自動録画する必要があります',
    ifPrompted: 'プロンプトが表示された場合',
    selectThisTab: '"このタブ"または"Current tab"を選択'
  }
}
